"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileService = void 0;
const api_1 = require("../api");
class FileService {
    constructor(fetch) {
        this.fetch = fetch;
        this.apiVersion = api_1.apiVersion;
    }
    getFileMetadataBySha(payload) {
        return this.fetch(`/${this.apiVersion}/files/${payload.sha}?type=${payload.type}`, {
            method: "GET",
        });
    }
    getFileUploadToken(params) {
        return this.fetch(`/${this.apiVersion}/files/upload-token`, {
            method: "POST",
            body: params.body,
        });
    }
}
exports.FileService = FileService;
